import { Menu, MenuItem } from '@mui/material';
import Rails from '@rails/ujs';
import Axios from 'axios';
import { useEffect, useState } from 'react';
import toastr from 'toastr';
import { taskStateById, taskStatusLabel } from '../Common/functions';
import { ISelectOption, TaskStatusVal } from '../Common/types';
import { AllProgressStatuses } from '../TaskManage/StatusField';

interface InlineTaskStatusProps {
  taskStatuses: TaskStatusVal[];
  taskTypeId: number;
}

interface TaskStatusBadgeProps {
  taskId: number;
  status: string;
  title?: string;
}

// one clickable status badge of a single task
const TaskStatusBadge = (props: TaskStatusBadgeProps) => {
  const [status, setStatus] = useState(props.status);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  useEffect(() => {
    setStatus(props.status);
  }, [props.status]);

  if (status === '-') {
    return <span title={props.title}>{taskStatusLabel(status)}</span>;
  }

  function handleChange(opt: ISelectOption): void {
    const previous = status;
    setStatus(opt.value);
    setAnchorEl(null);

    Axios.put(
      `/task_management/${props.taskId}.json`,
      { project_task: { status: opt.value } },
      {
        headers: {
          'X-CSRF-Token': Rails.csrfToken(),
          'Content-Type': 'application/json',
        },
      }
    ).catch((err) => {
      setStatus(previous);
      toastr.error('Status NOT updated');
      console.log(err);
    });
  }

  return (
    <>
      <a
        href="#"
        title={props.title}
        onClick={(e) => {
          e.preventDefault();
          setAnchorEl(e.currentTarget);
        }}
      >
        {taskStatusLabel(status)}
      </a>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {AllProgressStatuses.map((ps) => (
          <MenuItem key={ps.value} onClick={() => handleChange(ps)}>
            {ps.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const InlineTaskStatus = (props: InlineTaskStatusProps) => {
  const found = props.taskStatuses.find((ts) => ts.id === props.taskTypeId);

  if (!found || !found.task_id) {
    return taskStateById(props.taskStatuses, props.taskTypeId);
  }

  // split task (1/2, 2/2 ...) - a badge per part, each changed separately
  if (found.parts && found.parts.length > 1) {
    return (
      <span className="text-nowrap">
        {found.parts.map((part) => (
          <span key={part.task_id} className="m-r-xs">
            <TaskStatusBadge
              taskId={part.task_id}
              status={part.status}
              title={[part.label, part.machine].filter(Boolean).join(' ')}
            />
          </span>
        ))}
      </span>
    );
  }

  return <TaskStatusBadge taskId={found.task_id} status={found.status} />;
};

export default InlineTaskStatus;
